import { useMutation } from '@tanstack/react-query';
import { CreateRegisterRequest, UpdateRegisterRequest } from 'compliance-api/generated';
import { FormikErrors, FormikValues } from 'formik';
import { api } from '@/modules/common/api/index.ts';
import { REGISTERS_LIST_QUERY_KEY } from '@/modules/common/queries/registers.ts';
import { queryClient } from '@/modules/common/query.ts';
import { withErrorHandling } from '@/modules/common/utils/error-utils.tsx';

export const useCreateRegisterMutation = (
  setErrors?: (errors: FormikErrors<FormikValues>) => void,
) => {
  return useMutation({
    mutationFn: async (payload: CreateRegisterRequest) => {
      const response = await withErrorHandling(api.v1.createRegisterV1RegistersPost(payload), {
        loading: 'Creating label tag...',
        success: 'Label created',
        setErrors,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([REGISTERS_LIST_QUERY_KEY]);
    },
  });
};

export const useUpdateRegisterMutation = ({
  setErrors,
}: {
  setErrors: (errors: FormikErrors<FormikValues>) => void;
}) => {
  return useMutation({
    mutationFn: async (payload: UpdateRegisterRequest) => {
      const response = await withErrorHandling(api.v1.updateRegisterV1RegistersPatch(payload), {
        loading: 'Updating label...',
        success: 'Label updated',
        setErrors,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([REGISTERS_LIST_QUERY_KEY]);
    },
  });
};

export const useDeleteRegisterMutation = () => {
  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const response = await withErrorHandling(
        api.v1.removeRegisterV1RegistersIdDelete({ id: id }),
        {
          loading: 'Deleting label...',
          success: 'Label deleted',
        },
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([REGISTERS_LIST_QUERY_KEY]);
    },
  });
};
